'use strict';

var setValue = function setValue(fn, obj) {
    return function (key) {
        return fn(key, obj[key]);
    };
};

module.exports = function (fn, obj) {
    Object.keys(obj).forEach(setValue(fn, obj));
};